import {AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { AuthSessionService } from '../../../services/auth-session.service';
import { Router } from '@angular/router';
import {FilterbaseService} from "../top-filter/filter-base/services/filterbase.service";
import {ApiUrl} from "../../../shared/models/apiurl.models";
import {LoadingMaskServiceService} from "../../../components/loading-frame/loading-frame.component";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {TranslateService} from '@ngx-translate/core';
import {MainCategory} from "../../../models/header.model";
import {SystemApp} from "../../../constans/SystemConfigurations";
import {LoginAction, LoginService} from "../../../components/session/login/login.service";
import {Observable, throwError} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {AppService} from "../../../app.service";
import {AdvertisementEnum} from "../../../core/advertisement/advertisement.component";
import {ActionCallback} from "../../../components/page-actions/action-bar-button.component";
import {NadlanMapService} from "../../../components/nadlan-map/nadlan-map.service";

const MAP_HIDDEN_KEY = 's4a.nadlanMap.hidden';
const DESKTOP_MAP_MIN_WIDTH = 1024;

@Component({
    selector: 'app-main-content',
    templateUrl: './main-content.component.html',
    styleUrls: ['./main-content.component.css'],
    standalone: false
})

export class MainContentComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly authSession = inject(AuthSessionService);
  private readonly router = inject(Router);
  @ViewChild('shopToolbar') shopToolbar!: ElementRef<HTMLElement>;
  private filterObserver?: IntersectionObserver;
  private filterSectionElement?: ElementRef<HTMLElement>;
  @ViewChild('filterSection') set filterSection(element: ElementRef<HTMLElement> | undefined) {
    this.filterSectionElement = element;
    this.observeFilterSection();
  }
  isToolbarPinned = false;
  isFilterSectionVisible = true;
  itemsList!:any[];
  mainCategories!:MainCategory[];
  baseurl: string = SystemApp.base_url;
  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.apiKey.getJWTToken()
    })
  }
  // ── SCRUM-253: real-estate map ──────────────────────────────
  /** The map is offered on the real-estate (nadlan) results only. */
  isNadlan = false;
  isDesktop = true;
  mapHidden = false;          // desktop "הסתר מפה" (remembered)
  mobileMapOpen = false;      // phone: map / list toggle
  mapReloadKey = 0;
  /** What the list currently shows (initial load, infinite scroll, searches). */
  listedProducts: any[] = [];
  /** This results page's URL (captured on creation). */
  private pageUrl = '';

  constructor(public filterbaseService: FilterbaseService, public mapService: NadlanMapService,private http: HttpClient, private apiKey: ApiUrl, private loginService: LoginService, private loadingMaskServiceService: LoadingMaskServiceService,public translate:TranslateService, public appService: AppService) {
    // Filters / offset of THIS category page (see FilterbaseService.ensureScope).
    this.filterbaseService.ensureScope();
    this.loadData()
    this.isNadlan = (this.apiKey.getNameSpacePos('/', 3) || '').toLowerCase() === 'nadlan';
    // Back from an ad: keep the "חיפוש באזור זה" area the list was showing.
    this.pageUrl = this.router.url.split('#')[0];
    const area = this.mapService.lastArea;
    this.filterbaseService.mapBbox =
      area && this.isNadlan && area.url === this.pageUrl ? area.bbox : null;
    try { this.mapHidden = localStorage.getItem(MAP_HIDDEN_KEY) === '1'; } catch { this.mapHidden = false; }
    this.updateViewport();
    // Phone: back from an ad that was opened from the map → show the map again.
    const cam = this.mapService.cameraFor(this.pageUrl);
    if (this.isNadlan && !this.isDesktop && cam?.mobileMapOpen) {
      this.mobileMapOpen = true;
      if (typeof document !== 'undefined') document.body.style.overflow = 'hidden';
    }
  }

  get showDesktopMap(): boolean { return this.isNadlan && this.isDesktop && !this.mapHidden; }
  get showMobileMap(): boolean { return this.isNadlan && !this.isDesktop && this.mobileMapOpen; }

  @HostListener('window:resize')
  updateViewport(): void {
    if (typeof window === 'undefined') return;
    this.isDesktop = window.innerWidth >= DESKTOP_MAP_MIN_WIDTH;
    if (this.isDesktop && this.mobileMapOpen) this.toggleMobileMap();
    this.updatePinnedState?.();
  }

  setMapHidden(hidden: boolean): void {
    this.mapHidden = hidden;
    try { localStorage.setItem(MAP_HIDDEN_KEY, hidden ? '1' : '0'); } catch { /* private mode */ }
  }

  toggleMobileMap(): void {
    this.mobileMapOpen = !this.mobileMapOpen;
    document.body.style.overflow = this.mobileMapOpen ? 'hidden' : '';
  }

  /** "חיפוש באזור זה": reload the list for the visible map area. */
  onMapSearchArea(bbox: string): void {
    this.filterbaseService.mapBbox = bbox;
    this.reloadList(false);
    if (!this.isDesktop) this.toggleMobileMap();
  }

  onMapClearArea(): void {
    this.filterbaseService.mapBbox = null;
    this.reloadList(false);
  }

  private reloadList(reloadMap: boolean): void {
    this.loadingMaskServiceService.setOnLoadingMask(true, true);
    this.filterbaseService.offset = 1;
    this.filterbaseService.loadFilterData(this.filterbaseService.limit, this.filterbaseService.offset).subscribe({
      next: data => {
        this.loadingMaskServiceService.setOnLoadingMask(false, false);
        this.itemsList = data.object_list;
      },
      error: () => this.loadingMaskServiceService.setOnLoadingMask(false, false),
    });
    if (reloadMap) this.mapReloadKey++;
  }

  isLogin(){ return !!localStorage.getItem('is_logged_in') }
  ngOnInit(): void {
  }

  ngAfterViewInit(): void { this.updatePinnedState(); }

  ngOnDestroy(): void {
    this.filterObserver?.disconnect();
    this.mapService.lastArea = this.filterbaseService.mapBbox
      ? {url: this.pageUrl, bbox: this.filterbaseService.mapBbox} : null;
    this.filterbaseService.mapBbox = null;
    if (typeof document !== 'undefined') document.body.style.overflow = '';
  }

  private observeFilterSection(): void {
    this.filterObserver?.disconnect();
    if (!this.filterSectionElement?.nativeElement || typeof IntersectionObserver === 'undefined') {
      this.isFilterSectionVisible = !!this.filterSectionElement;
      return;
    }
    this.filterObserver = new IntersectionObserver(([entry]) => {
      this.isFilterSectionVisible = entry.isIntersecting;
    }, {threshold: 0.05});
    this.filterObserver.observe(this.filterSectionElement.nativeElement);
  }

  @HostListener('window:scroll')
  updatePinnedState(): void {
    if (!this.shopToolbar?.nativeElement) return;
    const stickyTop = window.innerWidth <= 700 ? 0 : 54;
    const top = this.shopToolbar.nativeElement.getBoundingClientRect().top;
    this.isToolbarPinned = window.scrollY > 0 && top <= stickyTop + 1;
  }

  scrollToFilters(): void {
    if (!this.filterIsOpen) this.filterIsOpen = true;
    setTimeout(() => {
      this.filterSectionElement?.nativeElement.scrollIntoView({behavior: 'smooth', block: 'start'});
    });
  }

  searchApply(): any {
    // Filters changed: list + map points (the map area, if any, stays).
    this.reloadList(true);
  }
  get activeFilters(): Array<{key: string; label: string; value: string}> {
    return this.filterbaseService.getActiveQuestions().map(({key, value}) => ({ key, label: this.filterbaseService.filterBases.find(filter => filter.key === key)?.label || key, value: this.formatFilterValue(value) })).filter(filter => !!filter.value);
  }
  removeFilter(key: string): void { this.filterbaseService.sendRemoveEvent(key); this.filterbaseService.deleteQuestion(key); }
  clearAllFilters(): void { this.filterbaseService.clearAllQuestions(); }
  private formatFilterValue(value: any): string {
    if (value === true) return 'כן';
    if (Array.isArray(value)) return value.map(item => item?.label || item?.value?.name || item).join(', ');
    if (value?.range) { const from = value.from?.label || value.from?.value?.name || value.from || ''; const to = value.to?.label || value.to?.value?.name || value.to || ''; return [from && `מ־${from}`, to && `עד ${to}`].filter(Boolean).join(' '); }
    if (value && typeof value === 'object') return value.label || value.value?.name || value.value?.value || '';
    return String(value || '');
  }
  private loadData() {
    this.mainCategories = []
    this.getPages().subscribe((res) => {
      this.mainCategories = res.map((cate:any) => {
        return{
          id: cate.id,
          name: cate.name,
          nameEng: cate.category.toLowerCase(),
          important: cate.important,
          icon: cate.icon,
          subcategories: cate.subcategories

        }})
    })

  }
  private handleObserverError(error: any): Observable<any>{
    return throwError(error.error || error)
  }
  getPages(): Observable<any>{
    return this.http.get(this.apiKey.getPages(), this.options)
      .pipe(map((res) => res ? res : null ),catchError(this.handleObserverError)
      );
  }
  logout() {
    // POD1-7: full logout - revoke the refresh token server-side and
    // drop the socket, not just clear the local flag.
    this.authSession.logout().subscribe();
    this.loginService.sendClickEvent(LoginAction.Close);
  }

  openLogin() {
    this.loginService.sendClickEvent(LoginAction.Open);
  }
  filterIsOpen: boolean = !AppService.isMobile();
  handleFilterToggle(value: boolean){
    this.filterIsOpen = value;
  }

  protected readonly AppService = AppService;
  protected readonly AdvertisementEnum = AdvertisementEnum;


  actionCallbacks = {
    filter: { callback : this.handleFilterToggle.bind(this), default: this.filterIsOpen, order: 1 },
    // Omit 'sort' to disable it
  };

}
